import React from 'react';
import { useSelector } from 'react-redux';
import { ArrowForward } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, SIZE_44, TRAILING_ICON } from '@yme/atoms/button';
import { Col, Container, Row } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/common/hooks';
import { navigationItemFromLink } from '@yme/components/Header/Menu/utils';
import { getCommon } from '@yme/selectors/index';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { DigitalDataMutation, getToForLinkComponent, isExternalLink, setDigitalData, } from '@yme/utils/common';
import { HeroInfo } from './HeroInfo';
import { ButtonsSectionStyled, LinkStyled } from './styled';
export function HeroSectionContent({ labels, buttonSettings, isRightToLeft }) {
    const { isMobileView } = useWindowSize();
    const { pageType } = useSelector(getCommon);
    const isButtonShowed = buttonSettings && !isMobileView;
    const trackNavigation = (link) => () => {
        if (pageType === 'yme/components/pages/home-page') {
            setDigitalData(DigitalDataMutation.NAVIGATION, {
                pageSection: 'hero',
                navigationGroup: '',
                navigationItem: navigationItemFromLink(link),
            });
        }
    };
    return (React.createElement(Container, { height: "100%" },
        React.createElement(FlexWrapper, { flexDirection: "column", justifyContent: "flex-end", pt: "16px", pbDesktop: "48px", pbMobile: "16px", pbTablet: "24px", height: "100%" },
            React.createElement(HeroInfo, { labels: labels }),
            isButtonShowed && (React.createElement(Row, null,
                React.createElement(Col, { lg: 6, md: 8 },
                    React.createElement(ButtonsSectionStyled, null, buttonSettings?.link && buttonSettings?.text ? (React.createElement(LinkStyled, { to: getToForLinkComponent(buttonSettings.link), onClick: trackNavigation(buttonSettings.link), target: isExternalLink(buttonSettings.link) ? '_blank' : '_self' },
                        React.createElement(Button, { width: "auto", buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, size: SIZE_44, label: buttonSettings.text, isRightToLeft: isRightToLeft, isDarkMode: true }))) : null)))))));
}
